<h3>Device Info</h3>
<p>Device Type: {{ deviceType }}</p>
<p>Device Model: {{ deviceModel }}</p>
<p *ngIf="isMobile">You're on a mobile device</p>
<p *ngIf="isDesktop">You're on a desktop device</p>